import { useState } from "react";
import { Button, Input, Modal } from "semantic-ui-react";
import { object, string } from "yup";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { updateGuestProfile } from "services/bookings";

const noError = {
  email: ""
}
export default function EditPopup(props: any): JSX.Element {
  const [loading, setLoading] = useState(false);
  const {
    hotel,
    updateRecordListByBookingNumber,
    popup,
    setPopup,
    editRecord,
    setEditRecord,
    fetchCount,
    setFetchCount,
    newPrearrival,
    setNewPrearrival,
  } = props
  const [error, setError] = useState(noError)

  const hotelName = props.hotel?.getHotelName()
  const showPhoneNumber = hotelName?.includes('parklane') || hotelName?.includes('bluepin')

  const updateGuestInfo = async () => {
    try {
      await object({
        email: string().optional().email("please enter a valid email"),
      }).validate(newPrearrival, { abortEarly: false })

      setLoading(true);
      setEditRecord({ ...editRecord, email: newPrearrival.email, phoneNumber: newPrearrival.phoneNumber })
      await updateGuestProfile({
        bookingNumber: editRecord.confirmationNumber || editRecord.bookingNumber,
        profileId: editRecord?.profile?.profileId,
        firstName: editRecord?.profile?.firstName,
        lastName: editRecord?.profile?.lastName,
        document: editRecord?.profile?.document,
        email: newPrearrival.email,
        phoneNumber: newPrearrival.phoneNumber,
      })

      setNewPrearrival({ ...newPrearrival, email: '', phoneNumber: '' })
      setPopup({ ...popup, edit: false })
      setError({ ...noError })
      updateRecordListByBookingNumber(editRecord.confirmationNumber || editRecord.bookingNumber, newPrearrival.email)
      setFetchCount(fetchCount + 1)
      setLoading(false);
    } catch (err: any) {
      console.log("err: probably missing profileId...")
      const errors = err?.inner?.reduce((acc: any, e: any) => {
        acc[e.path] = e.message
        return acc
      }, {})

      setLoading(false);
      setError({ ...errors })
    }
  }

  return (
    <Modal
      closeIcon
      style={{ width: "30rem" }}
      onClose={() => setPopup({ ...popup, edit: false })}
      open={popup.edit}
    >
      <Modal.Header className="text-left">
        <div>
          <span>Confirmation No:</span> <span>{editRecord?.confirmationNumber}</span>
        </div>
        <div>
          <span>Email:</span> <span>{editRecord?.profile?.email?.email}</span>
        </div>
        {showPhoneNumber ?
          <div>
            <span>Phone:</span> <span>{editRecord?.profile?.phoneNumber?.number}</span>
          </div> : <></>}
      </Modal.Header>
      <Modal.Content className="text-left">
        <div>
          <Input
            error={!!error.email}
            fluid
            name="email"
            placeholder="New Email"
            value={newPrearrival.email}
            onKeyUp={(evt: any) => {
              if (evt.key === "Enter") {
                updateGuestInfo();
              }
            }}
            onChange={(e, data) => setNewPrearrival({ ...newPrearrival, [data.name]: data.value })}
          />
        </div>
        {showPhoneNumber?
        <div style={{ marginTop: '1rem' }}>
          <PhoneInput
            inputStyle={{ width: "100%" }}
            country={'hk'}
            value={newPrearrival.phoneNumber}
            onChange={phone => setNewPrearrival({ ...newPrearrival, phoneNumber: !phone ? '' : `+${phone}` })} />
        </div>
        :<></>}
      </Modal.Content>
      <Modal.Actions >
        <Button color='black' onClick={() => setPopup({ ...popup, edit: false })}>
          Cancel
        </Button>
        <Button
          content="Update"
          loading={loading}
          disabled={loading}
          onClick={() => updateGuestInfo()}
          color="yellow"
        />
      </Modal.Actions>
    </Modal>
  )
}
